export type ServiceModality = "online" | "in_person" | "both";
export type SessionModality = "online" | "in_person";

// Bosnian labels for a therapist's working mode (online / in-person / both).
export const SESSION_MODALITY_LABELS_BS: Record<ServiceModality, string> = {
  online: "Samo online",
  in_person: "Samo uživo",
  both: "Online i uživo",
};

/**
 * Resolve the concrete session modality from the service's allowed modality
 * and the client's requested modality. Throws if the request contradicts the
 * service. `both` defaults to "online" when the request is absent.
 */
export function resolveSessionModality(
  serviceModality: ServiceModality,
  requested: SessionModality | undefined,
): SessionModality {
  if (serviceModality === "online") {
    if (requested === "in_person") {
      throw new Error("Ova usluga se ne nudi uživo.");
    }
    return "online";
  }
  if (serviceModality === "in_person") {
    if (requested === "online") {
      throw new Error("Ova usluga se nudi samo uživo.");
    }
    return "in_person";
  }
  return requested ?? "online";
}
